module.exports = __webpack_public_path__ + "img/logo-melhores-ongs.524d28b3.svg";